import { useGetSystemQuery } from "../generated/graphql";

type UseSystemProps = {
  systemId?: number;
  skip?: boolean;
  withOperator?: boolean;
  withUserDirectoryEnabled?: boolean;
  withHasSitesWithIntervals?: boolean;
};

export default ({
  systemId = -1,
  skip = false,
  withOperator = false,
  withUserDirectoryEnabled = false,
  withHasSitesWithIntervals = false,
}: UseSystemProps = {}) => {
  const { data, loading } = useGetSystemQuery({
    skip: skip || systemId === -1,
    variables: {
      systemId,
      withOperator,
      withUserDirectoryEnabled,
      withHasSitesWithIntervals,
    },
  });

  return { system: data?.system, loading };
};
